import { getStrippedCCSRoutes } from '@condo/domain';
import type { RouteRecordRaw } from 'vue-router';
import { portfolioSignOffCreateRamEmbedProps, portfolioSignOffDetailRamEmbedProps, portfolioSignOffRamEmbedProps } from './sign-off-ram-embed-route-props';

const CCSRouteMap = getStrippedCCSRoutes();

export const createMfhPortfolioRoutes = (): RouteRecordRaw[] => [
    {
        ...CCSRouteMap['sourcing.mfh-portfolios'],
        component: () => import('@/views/mfh/MfhPortfolios.vue'),
    },
    {
        ...CCSRouteMap['one.mfh-portfolio'],
        redirect: params => `${params.fullPath}/${CCSRouteMap['one.mfh-portfolio.detail'].path}`,
        components: {
            default: () => import('@/views/mfh/OneMfhPortfolio.vue'),
        },
        props: {
            default: route => ({ mfhPortfolioId: +route.params.mfhPortfolioId }),
        },
        children: [
            {
                ...CCSRouteMap['one.mfh-portfolio.detail'],
                components: {
                    default: () => import('@/components/mfh/portfolio/MFHPortfolioDetails.vue'),
                },
            },
            {
                ...CCSRouteMap['one.mfh-portfolio.tasks'],
                components: {
                    default: () => import('@/components/mfh/portfolio/MfhPortfolioTasks.vue'),
                },
                props: true,
            },
            {
                ...CCSRouteMap['one.mfh-portfolio.contacts'],
                components: {
                    default: () => import('@/components/mfh/portfolio/MfhPortfolioContacts.vue'),
                },
            },
            {
                ...CCSRouteMap['one.mfh-portfolio.timeline'],
                components: {
                    default: () => import('@/components/timeline/EventsTimeline.vue'),
                },
                props: {
                    default: route => ({ ...route.params }),
                },
            },
            {
                ...CCSRouteMap['one.mfh-portfolio.financing.overview'],
                components: {
                    default: () => import('@/components/mfh/portfolio/MfhPortfolioFinancingOverview.vue'),
                },
                props: true,
            },
            {
                ...CCSRouteMap['one.mfh-portfolio.purchasing.overview'],
                components: {
                    default: () => import('@/components/mfh/portfolio/MfhPortfolioPurchasingOverview.vue'),
                },
                props: true,
            },
            {
                ...CCSRouteMap['one.mfh-portfolio.sign-off-envelopes.overview'],
                components: {
                    default: () => import('@/components/ram/RamEmbed.vue'),
                },
                props: {
                    default: portfolioSignOffRamEmbedProps,
                },
            },
            {
                ...CCSRouteMap['one.mfh-portfolio.sign-off-envelope-create'],
                components: {
                    default: () => import('@/components/ram/RamEmbed.vue'),
                },
                props: {
                    default: portfolioSignOffCreateRamEmbedProps,
                },
            },
            {
                ...CCSRouteMap['one.mfh-portfolio.sign-off-envelope.details'],
                components: {
                    default: () => import('@/components/ram/RamEmbed.vue'),
                },
                props: {
                    default: portfolioSignOffDetailRamEmbedProps,
                },
            },
            {
                path: 'sheet-embedding/:mfhSheetEmbeddingId?',
                name: 'one.mfh-portfolio.sheet-embedding',
                components: {
                    default: () => import('@/views/mfh/MfhPortfolioSheetEmbedding.vue'),
                },
                props: {
                    default: route => ({
                        mfhPortfolioId: +route.params.mfhPortfolioId,
                        ...(route.params.mfhSheetEmbeddingId != null && route.params.mfhSheetEmbeddingId !== ''
                            ? { mfhSheetEmbeddingId: +route.params.mfhSheetEmbeddingId }
                            : {}),
                    }),
                },
            },
        ],
    },
];
